<template>
  <PageContainer>
    <!-- TODO: Update all icons with material icons. -->
    <div class="relative flex flex-col items-stretch text-left">
      <!-- ACCOUNT -->
      <h2>Account</h2>
      <!-- TODO: Move account settings into modal. -->
      <!-- TODO: If user is `anonymous` automatically open a dismissable modal to prompt account creation. -->
      <!--
      <div class="grid grid-cols-1 gap-4 w-full">
        <div @click="openAccountSettingsModal()" class="flex flex-row gap-2 w-full p-4 rounded-lg bg-gray-50 cursor-pointer">
          <div class="px-2">
            <h3>⚙️</h3>
          </div>
          <div>
            <h3>Account settings</h3>
          </div>
        </div>
      </div>
      -->
      <p v-if="anonymous" class="mb-4 text-center">Create an account to save your progress 🥸</p>
      <!-- TODO: Move Google button to component by making ActionButton a Vue Slot -->
      <button @click="googleSignIn()" :disabled="loading || google" class="button-secondary mt-0 inline-flex items-center">
        <img src="@/assets/google.svg" class="mr-2">
        <span v-if="google">Google account linked</span>
        <span v-else>Sign in with Google</span>
        <svg v-if="google" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon" class="h-4 ml-2"><path fill-rule="evenodd" stroke="currentColor" stroke-width="1" d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clip-rule="evenodd"></path></svg>
      </button>
      <div v-if="user?.zone">
        <h3>Timezone</h3>
        <p>{{ user?.zone }}</p>
      </div>
      <!-- TODO: Link with email and password. -->
      <!--
      <div v-if="!google">
        <div class="m-4 font-medium text-gray-500">OR</div>
        <div class="w-full mb-4 px-8">
          <AcccountNameInput ref='name'/>
        </div>
        <div class="w-full mb-4 px-8">
          <input type="email" name="email" v-model="email" placeholder="Email" class="w-full">
        </div>
        <div class="w-full mb-4 px-8">
          <input type="password" name="password" v-model="password" placeholder="Password" class="w-full">
        </div>
        <button @click="saveProfile()" :disabled="!$refs.name || !email || !password">Create account</button>
      </div>
      -->
      <button v-if="!anonymous" @click="logout()" class="button-secondary">Log Out</button>

      <!-- PROFILE -->
      <h2 class="mt-8">Profile</h2>
      <div class="grid grid-cols-1 gap-4 w-full">
        <!-- TODO: Update this section to look better. -->
        <div class="flex flex-row gap-4 items-top w-full p-4 rounded-lg bg-gray-50">
          <div class="text-2xl pt-2">🎯</div>
          <div class="w-full">
            <h3>Sleep targets</h3>
            <div class="flex flex-row gap-10">
              <div>
                <div>🛏️ Bed time</div>
                <div class="font-medium">{{ formatTime(target?.timeBed) }}</div>
              </div>
              <div>
                <div>⏰ Wake up</div>
                <div class="font-medium">{{ formatTime(target?.timeWake) }}</div>
              </div>
            </div>
          </div>
          <img v-if="!planStore.active" @click="sleepTargetModal = true" src="@/assets/edit.png" class="h-8 opacity-50 self-center">
        </div>

        <!-- Only show toolkit if there is at least one tool unlocked. -->
        <div v-if="hasTool" @click="goToToolkit()" class="flex flex-row gap-2 w-full p-4 rounded-lg bg-gray-50 cursor-pointer">
          <div class="px-2">
            <h3>💼</h3>
          </div>
          <div>
            <h3>Toolkit</h3>
          </div>
        </div>
        <!-- Only show plan if there is an active plan. -->
        <div v-if="planStore.active" @click="goToPlan()" class="flex flex-row gap-2 w-full p-4 rounded-lg bg-gray-50 cursor-pointer">
          <div class="px-2">
            <h3>📋</h3>
          </div>
          <div>
            <h3>Plan</h3>
          </div>
        </div>
      </div>
      <!-- FOOTER -->
      <div class="place-self-center mt-16 text-gray-500">Made with ❤ by the <span class="font-medium">sleep&me</span> team.</div>
    </div>
  </PageContainer>

  <!-- MODALS -->
  <SleepTargets
    v-if="sleepTargetModal"
    v-model="sleepTargetModal"
    @save-function="updateUserTargets"
  />
</template>

<script>
import { defineAsyncComponent } from 'vue'
  // signInWithPopup
import { getAuth, GoogleAuthProvider, linkWithPopup } from 'firebase/auth'
import { time24To12 } from '@/helpers/time'
import User from '@/models/user'
import PageContainer from '@/components/PageContainer'
// import AcccountNameInput from '@/components/AcccountNameInput'
import { mapStores } from 'pinia'
import { useToolStore } from '@/stores/tool'
import { usePlanStore } from '@/stores/plan'

export default {
  name: 'ProfilePage',
  components: {
    PageContainer,
    SleepTargets: defineAsyncComponent(
      () => import('@/components/modals/SleepTargets'),
    ),
    // AcccountNameInput,
  },
  data() {
    return {
      user: undefined,
      anonymous: false,
      loading: false,
      error: false,
      email: undefined,
      password: undefined,
      google: false,
      sleepTargetModal: false,
      target: {},
      hasTool: false,
    }
  },
  async beforeMount() {
    this.loadUser()
    const auth = getAuth()
    if (auth.currentUser.isAnonymous) {
      this.anonymous = true
    }
    this.google = this.googleLinked()
    await this.loadUserTargets()
    this.loadUserTools()
    this.loadPlan()
  },
  methods: {
    async loadUser() {
      this.user = await User.getCurrentUser()
    },
    googleSignIn() {
      const auth = getAuth()
      const provider = new GoogleAuthProvider()
      linkWithPopup(auth.currentUser, provider)
        .then(() => {
          // This gives you a Google Access Token. You can use it to access the Google API.
          // const credential = GoogleAuthProvider.credentialFromResult(result)
          this.google = true
          this.anonymous = false
          this.$router.push('/profile?googleLinked')
        })
        .catch((reason) => {
          console.error('Failed linkWithPopup', reason)
        })
    },
    googleLinked() {
      let linked = false
      try {
        const auth = getAuth()
        auth.currentUser.providerData.forEach(providers => {
          if (providers.providerId === 'google.com') {
            linked = true
          }
        })
      } catch(error) {
        linked = false
      }
      return linked
    },
    async logout() {
      const user = await User.getCurrentUser()
      user.logout()
        .then(() => {
          this.$router.push('/')
        })
    },
    async loadUserTargets() {
      User.getCurrentUser()
      .then(user => {
        this.user = user
        return user.getSleepTarget()
      })
      .then(target => {
        this.target.timeBed = target.bedTime
        this.target.timeWake = target.wakeTime
      })
    },
    async loadUserTools() {
      await this.toolStore.load()
      this.hasTool = this.toolStore.hasUnlocked
    },
    async loadPlan() {
      // Get active plan if it exists.
      await this.planStore.load()
    },
    updateUserTargets(bed, wake) {
      this.target.timeBed = bed
      this.target.timeWake = wake
    },
    formatTime(t) {
      return time24To12(t)
    },
    saveProfile() {
      // validateProfile()
      console.log('this.$refs', this.$refs)
      if (!this.$refs.name.validate()) {
        return
      }
      this.$refs.name.save()
    },
    goToToolkit() {
      this.$router.push('/toolkit')
    },
    goToPlan() {
      this.$router.push('/plan/outline')
    },
  },
  computed: {
    ...mapStores(useToolStore, usePlanStore),
  },
}
</script>